import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2049a5f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-0" }
const _hoisted_2 = {
  key: 0,
  class: "p-3"
}
const _hoisted_3 = { class: "m-0" }
const _hoisted_4 = {
  key: 0,
  class: "p-3"
}
const _hoisted_5 = { class: "m-0" }
const _hoisted_6 = {
  key: 0,
  class: "p-3"
}
const _hoisted_7 = { class: "m-0" }
const _hoisted_8 = {
  key: 0,
  class: "p-3"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "card col-12 col-lg-8" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "information" }
const _hoisted_14 = { class: "form-row mb-3" }
const _hoisted_15 = { class: "caption pr-2" }
const _hoisted_16 = { class: "col text-right text-sm-left" }
const _hoisted_17 = { class: "form-row mb-3" }
const _hoisted_18 = { class: "caption pr-2" }
const _hoisted_19 = { class: "col text-right text-sm-left" }
const _hoisted_20 = { class: "form-row mb-3" }
const _hoisted_21 = { class: "caption pr-2" }
const _hoisted_22 = { class: "col text-right text-sm-left" }
const _hoisted_23 = { class: "form-row mb-3" }
const _hoisted_24 = { class: "caption pr-2" }
const _hoisted_25 = { class: "col text-right text-sm-left" }
const _hoisted_26 = { class: "form-row mb-3" }
const _hoisted_27 = {
  id: "formTextHelp",
  class: "form-text text-muted"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.student.ladok.se/student/app/studentwebb/",
  target: "_blank"
}, " Ladok ", -1))
const _hoisted_29 = { class: "form-row" }
const _hoisted_30 = { class: "form-row" }
const _hoisted_31 = { class: "card-header" }
const _hoisted_32 = { class: "card-body" }
const _hoisted_33 = { class: "form-row" }
const _hoisted_34 = ["value", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!
  const _component_LuSpinner = _resolveComponent("LuSpinner")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_MandatoryFieldFlag = _resolveComponent("MandatoryFieldFlag")!
  const _component_CourseInput = _resolveComponent("CourseInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Modal, {
      ref: "success-modal",
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.reloadView()))
    }, _createSlots({
      default: _withCtx(() => [
        (_ctx.noteTaker !== null)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.popupSuccessMessage), 1))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      (_ctx.noteTaker !== null)
        ? {
            name: "header",
            fn: _withCtx(() => [
              _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t("note-taking-request.popup-success.title", {
            name: _ctx.noteTaker.firstName,
          })), 1)
            ])
          }
        : undefined
    ]), 1536),
    _createVNode(_component_Modal, { ref: "error-modal" }, _createSlots({
      default: _withCtx(() => [
        (_ctx.noteTaker !== null)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t("shared.popup-error.message")), 1))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      (_ctx.noteTaker !== null)
        ? {
            name: "header",
            fn: _withCtx(() => [
              _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("shared.popup-error.title", {
            name: _ctx.noteTaker.firstName,
          })), 1)
            ])
          }
        : undefined
    ]), 1536),
    _createVNode(_component_Modal, { ref: "alert-modal" }, _createSlots({
      default: _withCtx(() => [
        (_ctx.noteTaker !== null)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t("note-taking-request.alert-message")), 1))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      (_ctx.noteTaker !== null)
        ? {
            name: "header",
            fn: _withCtx(() => [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("shared.popup-error.title", {
            name: _ctx.noteTaker.firstName,
          })), 1)
            ])
          }
        : undefined
    ]), 1536),
    _createVNode(_component_Modal, {
      ref: "not-possible-modal",
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToStudentHome()))
    }, _createSlots({
      default: _withCtx(() => [
        (_ctx.noteTaker !== null)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
              _createTextVNode(_toDisplayString(_ctx.$t("note-taking-request.popup-not-possible.message")), 1),
              (_ctx.noteTaker.isAnActiveStudentInNeed)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t("note-taking-request.popup-not-possible.student-message")), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t("note-taking-request.popup-not-possible.interim-message")), 1))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      (_ctx.noteTaker !== null)
        ? {
            name: "header",
            fn: _withCtx(() => [
              _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.$t("note-taking-request.popup-not-possible.title", {
            name: _ctx.noteTaker.firstName,
          })), 1)
            ])
          }
        : undefined
    ]), 1536),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_LuSpinner, { key: 0 }))
      : _createCommentVNode("", true),
    (
      _ctx.noteTaker !== null &&
      !_ctx.noteTaker.isAnActiveStudentInNeed &&
      !_ctx.personHasInterimPersonalId
    )
      ? (_openBlock(), _createElementBlock("form", {
          key: 1,
          class: "row justify-content-center",
          onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendApplication && _ctx.sendApplication(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.$t("note-taking-request.title")), 1),
            _createElementVNode("span", {
              innerHTML: _ctx.$t('note-taking-request.description'),
              class: "description"
            }, null, 8, _hoisted_12),
            _createVNode(_component_Accordion, {
              expanded: _ctx.noteTaker.id === 0,
              class: "mb-3"
            }, {
              button: _withCtx(() => [
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("note-taking-request.info-about-you")), 1)
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("person.personalId")), 1),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.noteTaker.personalId), 1)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("person.name")), 1),
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.noteTaker.firstName) + " " + _toDisplayString(_ctx.noteTaker.lastName), 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("person.email")), 1),
                  _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.noteTaker.email), 1)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t("person.telephoneNumber")), 1),
                  _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.noteTaker.telephoneNumber), 1)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("small", _hoisted_27, [
                    _createTextVNode(_toDisplayString(_ctx.$t("note-taking-request.edit-information-ladok")) + " ", 1),
                    _hoisted_28
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_TextInput, {
                    label: _ctx.$t('person.address'),
                    maxLength: 250,
                    value: _ctx.noteTaker.address,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.noteTaker.address) = $event)),
                    required: ""
                  }, null, 8, ["label", "value"])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_TextInput, {
                    label: _ctx.$t('person.postcode'),
                    maxLength: 10,
                    value: _ctx.noteTaker.postcode,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.noteTaker.postcode) = $event)),
                    required: true
                  }, null, 8, ["label", "value"]),
                  _createVNode(_component_TextInput, {
                    label: _ctx.$t('person.city'),
                    maxLength: 250,
                    value: _ctx.noteTaker.city,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.noteTaker.city) = $event)),
                    required: true
                  }, null, 8, ["label", "value"])
                ])
              ]),
              _: 1
            }, 8, ["expanded"])
          ]),
          (_ctx.courses !== null)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "card col-12 col-lg-8",
                onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendApplication && _ctx.sendApplication(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("shared.courses")), 1),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t("note-taking-request.choose-courses-label")) + " ", 1),
                    _createVNode(_component_MandatoryFieldFlag)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.terms, (term) => {
                    return (_openBlock(), _createBlock(_component_Accordion, {
                      key: term,
                      class: "mb-3",
                      expanded: term === _ctx.currentTerm
                    }, {
                      button: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.getTermString(term)), 1)
                      ]),
                      content: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCoursesByTerm(term), (course) => {
                          return (_openBlock(), _createBlock(_component_CourseInput, {
                            key: course.courseCode,
                            course: course,
                            courseOccurrenceId: _ctx.getCourseOccurrenceId(course.courseUid),
                            tooltipText: _ctx.tooltipText(course.disabled, course.courseUid),
                            isSupportCourse: _ctx.isSupportCourse(course.courseUid),
                            isCompleted: _ctx.isCompletedCourse(course.courseUid),
                            isDeletedByAdmin: _ctx.isDeletedByAdmin(course.courseUid),
                            onCourseCheckedChanged: _ctx.onCourseCheckedChanged
                          }, null, 8, ["course", "courseOccurrenceId", "tooltipText", "isSupportCourse", "isCompleted", "isDeletedByAdmin", "onCourseCheckedChanged"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["expanded"]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("button", {
                      id: "cancelBtn",
                      type: "button",
                      class: "btn btn-outline-primary mb-3",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goToStudentHome()))
                    }, _toDisplayString(_ctx.$t("shared.cancel")), 1),
                    _createElementVNode("input", {
                      type: "submit",
                      class: "btn btn-primary mb-3",
                      value: _ctx.submitButtonText,
                      disabled: _ctx.hasBeenSent || !_ctx.dataIsUpdated
                    }, null, 8, _hoisted_34)
                  ])
                ])
              ], 32))
            : _createCommentVNode("", true)
        ], 32))
      : _createCommentVNode("", true)
  ], 64))
}